export default __webpack_public_path__ + "static/media/team-1.c4f6a393.png";